module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA/CAYAAAAhZaJUAAAAE0lEQVQoU2M4c+bMf4ZRgowwAAA6zNVeEvn7bwAAAABJRU5ErkJggg=="